import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
mountLegislature('california-state-assembly', STATE_URL, 'Y').catch(
  console.error
);
